import type { PropsWithChildren } from "react";
import { useEffect } from "react";
import { styled } from "styled-components";

import { zIndex } from "common/constants/zIndex";

export const CallToActionOverlay = ({ children }: PropsWithChildren) => {
  useEffect(() => {
    document.body.style.overflow = "clip";

    const type = "touchmove";
    const listener = (e: TouchEvent) => e.preventDefault();

    document.addEventListener(type, listener, { passive: false });

    return () => {
      document.body.style.overflow = "unset";
      document.removeEventListener("touchmove", listener);
    };
  }, []);

  return <Container>{children}</Container>;
};

const Container = styled.svg`
  fill: black;
  height: 100%;
  left: 0;
  opacity: 0.7;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: ${zIndex.coachmarkOverlay};
`;
